window.imageSizeHandler = () => {
  const images = document.querySelectorAll('.jsSetImageSize');

  images.forEach(image => {
    const imageWidth = image.clientWidth,
      imageHeight = imageWidth * 2 / 3;

    image.style.height = `${imageHeight}px`
  });
};